import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { useState as i } from "react";
import { NextgenImage as d, LoaderType as l } from "@nextgen-web-framework/all";
import s from "./components/SkeletonLoader/SkeletonLoader.js";
import './assets/HelpDeskImg.css';const c = "#ffffff", g = "#396e75", _ = "#e5fdff", u = "#546223", f = "#f0fae5", z = "#a65523", V = "#fff1e8", k = "#7f3e3e", C = "#ffe2e2", h = "#62625a", m = "#f8f8e7", y = "#38539a", p = "#707070", b = "#c8f8d1", v = "#87c9c8", B = "#5291b1", O = "rgba(82, 145, 177, 0.1019607843)", G = "#445685", w = "#181d61", R = "rgba(24, 29, 97, 0.1019607843)", W = "#5969d6", L = "#ea999d", S = "#b6577e", T = "rgba(182, 87, 126, 0.1019607843)", x = "#7e3e80", N = "#1e247f", Y = "rgba(30, 36, 127, 0.1019607843)", A = "#da7600", I = "#107f47", j = "#d91734", H = "_html_1gu1y_75", P = "_helpdesk_1gu1y_142", D = "_division_1gu1y_165", E = "_title_1gu1y_179", K = "_description_1gu1y_189", q = "_icon_1gu1y_209", F = "_footer_1gu1y_151", J = "_image_1gu1y_238", M = {
  amwayWhite: c,
  darkBlue: g,
  lightBlue: _,
  darkGreen: u,
  lightGreen: f,
  darkOrange: z,
  lightOrange: V,
  darkRed: k,
  lightRed: C,
  darkYellow: h,
  lightYellow: m,
  darkPurple: y,
  darkGrayOnWhite: p,
  dataVizColor1: b,
  dataVizColor2: v,
  dataVizColor3: B,
  dataVizColor3Background: O,
  dataVizColor4: G,
  dataVizColor5: w,
  dataVizColor5Background: R,
  dataVizColor6: W,
  dataVizColor7: L,
  dataVizColor8: S,
  dataVizColor8Background: T,
  dataVizColor9: x,
  dataVizColor10: N,
  dataVizColor10Background: Y,
  dataVizAlertOrange: A,
  dataVizSuccessGreen: I,
  dataVizWarningRed: j,
  "no-visible": "_no-visible_1gu1y_34",
  html: H,
  helpdesk: P,
  "footer-nav-link": "_footer-nav-link_1gu1y_151",
  "helpdesk-container": "_helpdesk-container_1gu1y_156",
  division: D,
  "button-container": "_button-container_1gu1y_170",
  title: E,
  description: K,
  "button-label": "_button-label_1gu1y_201",
  icon: q,
  footer: F,
  "footer-container": "_footer-container_1gu1y_229",
  image: J,
  "footer-nav-heading": "_footer-nav-heading_1gu1y_244",
  "footer-nav-heading-item": "_footer-nav-heading-item_1gu1y_254"
}, $ = ({ imageUrl: a, alt: t }) => {
  const [e, n] = i(!0);
  return /* @__PURE__ */ r("div", { className: M.image, children: [
    /* @__PURE__ */ o(d, { loaderType: l.CONTENTSTACK, src: a, alt: t, onLoad: () => n(!1) }),
    e && /* @__PURE__ */ o(s, { height: 36 })
  ] });
};
export {
  $ as H,
  M as s
};
//# sourceMappingURL=HelpDeskImg-e3f7128c.mjs.map
